import React, { useEffect, useState, useRef } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomAutocomplete from "../../AutoComplete/AutoComplete";
import axiosInstance from "../../../lib/axios";
import CrudButtons from "../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "AccLgrpName", label: "SubGroup Name", minWidth: 100 },
  { id: "AccLgrpAbvr", label: "Abbreviation", minWidth: 50 },
  { id: "accGrpName", label: "Group Name", minWidth: 100 },
];

const SubGroupMaster = () => {
  const [formData, setFormData] = useState({
    AccLgrpName: "",
    AccLgrpAbvr: "",
    AccGrpId: "",
  });

  const [error, setError] = useState({
    AccLgrpName: false,
    AccGrpId: false,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [UserId] = useState(sessionStorage.getItem("UserId") || "1");
  const [currentAccLgrpId, setCurrentAccLgrpId] = useState(null);
  const [jobTitle, setJobTitle] = useState([]);
  const [mode, setMode] = useState("view");
  const [Status, setStatus] = useState("1");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const [lastData, setLastData] = useState(null);

  const AccLgrpNameRef = useRef(null);
  const AccLgrpAbvrRef = useRef(null);
  const AccGrpIdRef = useRef(null);

  useEffect(() => {
    // console.log("formData updated:", formData);
  }, [formData]);

  // Filling the group dropdown
  useEffect(() => {
    const fetchGroupDropdown = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.post("AccGrp/GetAccGrpDrp", {});
        if (response.data && Array.isArray(response.data)) {
          const formattedOptions = response.data.map((item) => ({
            Id: item.AccGrpId,
            Name: item.AccGrpName,
          }));
          setJobTitle(formattedOptions);
        } else if (response.data.Data && Array.isArray(response.data.Data)) {
          const formattedOptions = response.data.Data.map((item) => ({
            Id: item.AccGrpId,
            Name: item.AccGrpName,
          }));
          setJobTitle(formattedOptions);
        } else {
          toast.info("No group dropdown data available");
        }
      } catch (error) {
        console.error("Error fetching group dropdown:", error);
        toast.error("Error fetching group dropdown data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchGroupDropdown();

    if (location.state && location.state.AccLgrpId) {
      setCurrentAccLgrpId(location.state.AccLgrpId);
      fetchAccLgrpData(location.state.AccLgrpId, "L");
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post("AccLgrp/GetAccLgrpDashBoard", {
          SearchText: "",
        });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error("No data found in response");
          setRows([]);
          setDataForPrint({});
        }
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
        toast.error("Error fetching dashboard data");
      }
    };
    getRow();
  }, []);

  // Retrieving the data
  const fetchAccLgrpData = async (id, flag) => {
    try {
      const response = await axiosInstance.post("AccLgrp/RetriveAccLgrp", {
        AccLgrpId: parseInt(id),
        Flag: flag,
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const accLgrpData = Array.isArray(response.data.Data) ? response.data.Data[0] : response.data.Data;
        if (accLgrpData) {
          setFormData({
            AccLgrpName: accLgrpData.AccLgrpName || "",
            AccLgrpAbvr: accLgrpData.AccLgrpAbvr || "",
            AccGrpId: accLgrpData.AccGrpId?.toString() || "",
          });
          setStatus(accLgrpData.Status?.toString() || "0");
          setIsFormDisabled(true);
          setCurrentAccLgrpId(accLgrpData.AccLgrpId);
          setMode("view");
        } else {
          toast.info("No subgroup data found in response");
          setFormData({
            AccLgrpName: "",
            AccLgrpAbvr: "",
            AccGrpId: "",
          });
          setStatus("0");
          setIsFormDisabled(true);
          setMode("view");
        }
      } else {
        toast.info(response.data.Message || "No subgroup data found for the given ID");
        setFormData({
          AccLgrpName: "",
          AccLgrpAbvr: "",
          AccGrpId: "",
        });
        setStatus("0");
        setIsFormDisabled(true);
        setMode("view");
      }
    } catch (error) {
      console.error("Error fetching subgroup data:", error);
      toast.error("Error fetching subgroup data");
    }
  };

  const handleInputChange = (event, newValue) => {
    if (event && event.target) {
      const { name, value } = event.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
      if (name === "AccLgrpName") {
        setError((prev) => ({ ...prev, [name]: !value }));
      }
    } else {
      const selectedId = newValue ? newValue.Id.toString() : "";
      setFormData((prev) => ({
        ...prev,
        AccGrpId: selectedId,
      }));
      setError((prev) => ({ ...prev, AccGrpId: !selectedId }));
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === AccLgrpNameRef.current) {
        AccLgrpAbvrRef.current.focus();
      } else if (event.target === AccLgrpAbvrRef.current) {
        AccGrpIdRef.current.focus();
      } else {
        handleSave();
      }
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  // Submit Button Code
  const handleSave = async () => {
    let hasError = false;

    if (!formData.AccLgrpName) {
      setError((prev) => ({ ...prev, AccLgrpName: true }));
      toast.error("Subgroup Name is required");
      hasError = true;
    }

    if (!formData.AccGrpId) {
      setError((prev) => ({ ...prev, AccGrpId: true }));
      toast.error("Group is required");
      hasError = true;
    }
    if (hasError) return;

    try {
      const payload = {
        AccGrpId: parseInt(formData.AccGrpId),
        AccLgrpName: formData.AccLgrpName,
        AccLgrpAbvr: formData.AccLgrpAbvr,
        Status: Status,
        CreatedBy: parseInt(UserId),
        LockSt: "1",
        Remark: "",
        LockId: parseInt(UserId),
      };

      let response;
      if (mode === "edit") {
        payload.AccLgrpId = currentAccLgrpId;
        console.log("Update Payload:", payload);
        response = await axiosInstance.post("AccLgrp/UpdateAccLgrp", payload);
      } else {
        console.log("Insert Payload:", payload);
        response = await axiosInstance.post("AccLgrp/InsertAccGrp", payload);
      }

      console.log("Save Response:", response.data);

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message || "Subgroup saved successfully");
        const newId =
          response.data.Data?.AccLgrpId ||
          response.data.Data ||
          response.data.AccLgrpId ||
          currentAccLgrpId;
        if (newId) {
          await fetchAccLgrpData(newId, "L");
          setCurrentAccLgrpId(newId);
          setMode("view");
          setIsFormDisabled(true);
        } else {
          toast.error("No ID returned from save operation");
        }
      } else {
        toast.error(response.data.Message || "Failed to save subgroup");
      }
    } catch (error) {
      console.error("Error saving/updating subgroup:", error);
      toast.error("Error saving subgroup");
    }
  };

  // Code to edit the record
  const handleEdit = async () => {
    if (!currentAccLgrpId) {
      toast.error("No record selected to edit");
      return;
    }
    let Flag = await checkAndLock(currentAccLgrpId, "AccLgrp", "AccLgrpId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        setTimeout(() => AccLgrpNameRef.current.focus(), 0);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Lock", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setLastData(formData);
    setMode("add");
    setIsFormDisabled(false);
    setFormData({
      AccLgrpName: "",
      AccLgrpAbvr: "",
      AccGrpId: "",
    });
    setStatus("1");
    setCurrentAccLgrpId(null);
    setError({ AccLgrpName: false, AccGrpId: false });
    setTimeout(() => AccLgrpNameRef.current.focus(), 0);
  };

  const handleNext = async () => {
    if (currentAccLgrpId) {
      await fetchAccLgrpData(currentAccLgrpId, "N");
    }
  };

  const handlePrevious = async () => {
    if (currentAccLgrpId && currentAccLgrpId > 1) {
      await fetchAccLgrpData(currentAccLgrpId, "P");
    }
  };

  const handleCancel = async () => {
    try {
      if (currentAccLgrpId && mode === "edit") {
        await UnLock(currentAccLgrpId, "AccLgrp", "AccLgrpId");
      }
      if (lastData) {
        setFormData(lastData);
      } else if (currentAccLgrpId) {
        await fetchAccLgrpData(currentAccLgrpId, "L");
      }
      setMode("view");
      setIsFormDisabled(true);
    } catch (error) {
      toast.error("Error occurred while cancelling");
    }
  };

  const handleExit = () => {
    navigate("/subgrpmsttable");
  };

  const handleDeleteClick = () => {
    if (currentAccLgrpId) {
      setOpenConfirmDialog(true);
    } else {
      toast.error("No record selected to delete");
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    let Flag = await checkAndLock(currentAccLgrpId, "AccLgrp", "AccLgrpId");
    switch (Flag) {
      case 0:
        await fetchAccLgrpData(currentAccLgrpId, "D");
        await fetchAccLgrpData(currentAccLgrpId, "N");
        setOpenConfirmDialog(false);
        setMode("view");
        setIsFormDisabled(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Lock", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: "700px", sm: "550px" } }}>
        <ToastContainer />
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                onClick={handlePrevious}
                sx={{
                  backgroundColor: "#635BFF",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: { xs: "none", sm: "block" },
                }}
                disabled={mode !== "view" || !currentAccLgrpId || currentAccLgrpId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                className="three-d-button-next"
                onClick={handleNext}
                sx={{ backgroundColor: "#635BFF", display: { xs: "none", sm: "block" } }}
                disabled={mode !== "view" || !currentAccLgrpId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              GL SubGroup Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="SubGroups"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDeleteClick}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="AccLgrpName"
                  name="AccLgrpName"
                  label={
                    <span>
                      Subgroup Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  disabled={isFormDisabled}
                  value={formData.AccLgrpName}
                  onChange={handleInputChange}
                  error={error.AccLgrpName}
                  helperText={error.AccLgrpName && "Subgroup Name is required"}
                  inputRef={AccLgrpNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="AccLgrpAbvr"
                  name="AccLgrpAbvr"
                  label={<span>Abbreviation</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  disabled={isFormDisabled}
                  value={formData.AccLgrpAbvr}
                  onChange={handleInputChange}
                  inputRef={AccLgrpAbvrRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <CustomAutocomplete
                  options={jobTitle}
                  id="AccGrpId-autocomplete"
                  name="AccGrpId"
                  label={
                    <span>
                      Group <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  getOptionLabel={(option) => option.Name || ""}
                  value={jobTitle.find((option) => option.Id === parseInt(formData.AccGrpId)) || null}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.AccGrpId}
                  helperText={error.AccGrpId ? "Group is required" : ""}
                  loading={isLoading}
                  ref={AccGrpIdRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === "view" && (
              <>
                <Button
                  variant="contained"
                  sx={{ mr: 1, background: "linear-gradient(290deg, #d4d4d4, #ffffff)" }}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{ mr: 1, background: "linear-gradient(290deg, #a7c5e9, #ffffff)" }}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: "none" }}>
        {Object.keys(DataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="GL SubGroup Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubGroupMaster;